import React from "react";
import moment from "moment-timezone";
import withStyles from "isomorphic-style-loader/withStyles";
import cx from "classnames";
import { api, profilePhotouploadDir } from "../../../../config";
import bt from '../../../../components/commonStyle.css';
import s from './MessagesItemCommon.css';


const MessagesItemCommon = ({ defaultIcon, text, userType, userImage, createdAt }) => {
  let avatarImage = userImage ? `${api.apiEndpoint + profilePhotouploadDir}medium_${userImage}` : defaultIcon
  const formattedDate = moment(parseInt(createdAt)).format('DD-MM-YYYY / hh:mm A')
  return (
    <div className={cx(bt.space4)}>
      <div className={cx({ [s.displayFlexReverse]: userType == 'user' }, s.messagesItemsContainer)}>
        <div className={s.messagesItemsWrapper}>
          <div className={cx(s.messagesItemsImgContainer, { [s.messagesItemsDefaultImgContainer]: !userImage })}>
            <img src={avatarImage} alt="userImg" className={cx({ [s.messagesItemsImg]: userImage }, { [s.messagesItemsDefaultImg]: !userImage })} />
          </div>
        </div>
        <div className={cx(s.messagesItemsInfoContainer, { ['messagesItemsInfoUserRadius']: userType == 'partnerDetails' }, { ['messagesItemsInfoPartnerRadius']: userType == 'user' })}>
          <div className={cx(bt.commonSize16, bt.fontWeight400, bt.primaryColor, bt.textAlignStart, bt.whiteSpacePreWrap)}>{text} </div>
          <div className={cx(bt.commonSize14, bt.fontWeight400, bt.secondaryColor, bt.textAlignEnd)}>{formattedDate}</div>
        </div>
      </div>
    </div>
  )
}

export default withStyles(bt, s)(MessagesItemCommon);
